export default __webpack_public_path__ + "static/packed-767a91a49b2b0c1948650572418ba24b.png";